import React, { useState, useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import { isMobile } from "react-device-detect";
import FilterData from "./data";
import { countProducts, filterTagsByAttribute } from "utils/filters";
import { useDispatch, useSelector } from "react-redux";
import { useGlobalContext } from "context/global";
import { trackAppliedFilters } from "services/analytics";
import { ReactComponent as FilterIcon } from "assets/svgs/filters.svg";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import { applyFilters, toggleFilterPanel } from "slices/filters";

const FiltersPanel = ({ filters }) => {
	const dispatch = useDispatch();
	const { collections, tags, bundles, isFiltersOpen } = useSelector((state) => state.filters);
	const [totalProducts, setTotalProducts] = useState(countProducts(collections) ?? 0);
	const { translation } = useGlobalContext();

	useEffect(() => {
		setTotalProducts(countProducts(collections));
	}, [collections, tags, bundles]);

	const handleApplyFilters = () => {
		dispatch(applyFilters());
		const activeFilters = filterTagsByAttribute(tags, "isActive");
		trackAppliedFilters(activeFilters);
	};

	const pendingChanges = [...Object.values(tags || {}), ...Object.values(bundles || {})]
		.some(t => t.isSettled !== t.isActive);

	return (
		<SlidingPane
			from="left"
			hideHeader={true}
			width={isMobile ? "100%" : "455px"}
			overlayClassName="z-[100]"
			className="filters-pane"
			isOpen={isFiltersOpen}
			onRequestClose={() => dispatch(toggleFilterPanel())}
		>
			<div className="panel">
				<div className="sticky bg-white z-10 top-0 py-5 flex justify-between items-center">
					<div className="flex content-between items-center">
						<FilterIcon />
						<h3 className="ml-2">Filter</h3>
					</div>
					<button
						className="bg-[#F9F9F9] hover:bg-white p-1 rounded-full cursor-pointer flex items-center"
						onClick={() => dispatch(toggleFilterPanel())}>
						<Close className="w-3 h-3" />
					</button>
				</div>

				<div className="content">
					<FilterData data={filters?.data} />
				</div>
				<div className="sticky w-full bottom-0 flex flex-col bg-white m-auto items-center py-6">
					<div className="font-base text-[#727272] font-bold pb-2">
						{filters?.title?.replace(`"X"`, totalProducts)}
					</div>
					<button onClick={handleApplyFilters} disabled={!pendingChanges}
						className="btn-primary tracking-wider md:text-base px-8 md:px-auto">
						{translation.other?.applyFilters}</button>
				</div>
			</div>
		</SlidingPane>
	);
};

export default FiltersPanel;
